export default __webpack_public_path__ + "static/media/grow.16a6fa7b.png";